import { ICheckoutParams, PropertiesAPI } from "../../services/hcnApi";

export const checkoutUseCase = async (params: ICheckoutParams) => {
  return await PropertiesAPI.checkout(params);
};
